import { getConfigDataServer } from '../../../config'
import { setRainbowData, setRainbowProcessing, setRainbowError, GET_RAINBOW_DATA } from './actions'
import { getUserRainbowCategories } from '..'

const log = console
async function getRainbowDataHandler ({ store }) {
  const { config, user, auth } = store.getState()
  try {
    // Do not set processing before the auth gate — an early return with
    // processing=true prevents UserDetail from retrying the fetch.
    if (auth.get('processing') !== false) {
      return
    }

    store.dispatch(setRainbowProcessing())
    const uid = user.getIn(['userDetail', 'data', 'uid']) // get uid we want RC for
    const data = await getUserRainbowCategories({
      auth,
      uid,
      server: getConfigDataServer(config, 'brooklyn'),
    })

    store.dispatch(
      setRainbowData({
        data,
      }),
    )
  } catch (error) {
    log.error(error, 'Error getting user rainbow categoriew.')
    store.dispatch(
      setRainbowError({
        error,
      }),
    )
  }
}

export default (store) => (next) => (action) => {
  const { type } = action
  switch (type) {
    case GET_RAINBOW_DATA:
      getRainbowDataHandler({ store, action })
      break
    default:
      break
  }
  next(action)
}
